<app-company-hero></app-company-hero>
<app-company-values></app-company-values>

<section>
	<div class="container">
	  <div class="row align-items-lg-center">
		<div class="col-12 col-md-12 col-lg-12">
		  <app-cta></app-cta>
		</div>
	  </div>
	</div>
  </section>
  